module.exports = "pegasus_template/assets/hexagon-twitter.png";